import script from "./BlueSliderLightBox.vue?vue&type=script&setup=true&lang=js"
export * from "./BlueSliderLightBox.vue?vue&type=script&setup=true&lang=js"

import "./BlueSliderLightBox.vue?vue&type=style&index=0&id=808fcb54&lang=css&scoped=true"
import "./BlueSliderLightBox.vue?vue&type=style&index=1&id=808fcb54&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-808fcb54"]])

export default __exports__